import { apiSlice } from "../../../app/api/apiSlice"

export const formDetailsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getCrmDetails: builder.mutation({
            query: (request) => ({
                url: `/crm/${request.userId}/getCrmDetails/${request.crmId}`,
                method: 'GET'
            })
        }),
        getClientAndAccounts: builder.mutation({
            query: (request) => ({
                url: `/crm/getClientAndAccounts`,
                method: 'POST',
                body: {
                    ...request
                }
            })
        }),
        updateClientAndAccounts: builder.mutation({
            query: (request) => ({
                url: `/crm/updateClientAndAccounts`,
                method: 'POST',
                body: {
                    ...request
                }
            })
        }),
        deleteClient: builder.mutation({
            query: (request) => ({
                url: `/crm/deleteClient`,
                method: 'POST',
                body: {
                    ...request
                }
            })
        }),
        deleteAccount: builder.mutation({
            query: (request) => ({
                url: `/crm/deleteAccount`,
                method: 'POST',
                body: {
                    ...request
                }
            })
        }),
        createClientAccount: builder.mutation({
            query: (request) => ({
                url: `/crm/createClientAccount`,
                method: 'POST',
                body: {
                    ...request
                }
            })
        }),
        getClientsBasicDetails: builder.mutation({
            query: (request) => ({
                url: `/crm/client/getClientsBasicDetails/${request.crmId}`,
                method: 'GET'
            })
        }),
        getAccountsBasicDetails: builder.mutation({
            query: (request) => ({
                url: `/crm/account/getAccountsBasicDetails/${request.clientId}`,
                method: 'GET'
            })
        }),
        getClientDocuments: builder.mutation({
            query: clientId => ({
                url: `/crm/client/document/getDocuments/${clientId}`,
                method: 'GET'
            })
        }),
        addClientDocuments: builder.mutation({
            query: (request) => {
                let formData = new FormData()
                request.documents.forEach(file => {
                    formData.append("documents", file.originFileObj)
                })

                return {
                  url: `/crm/client/document/addDocument/${request.clientId}`,
                  method: 'POST',
                  body:  formData,
                  formData: true  
                };
              }
        }),
        deleteClientDocument: builder.mutation({
            query: (request) => ({
                url: `/crm/client/document/deleteDocument`,
                method: 'POST',
                body: {
                    ...request
                }
            })
        }),
        addBulkClientDocuments: builder.mutation({
            query: (request) => {
                let formData = new FormData()
                formData.append("crmId", request.crmId)
                formData.append("userId", request.userId)
                formData.append("clientZippedDocuments", request.zipFile[0].originFileObj)
  
                return {
                  url: `/crm/client/document/bulk/add`,
                  method: 'POST',
                  body:  formData,
                  formData: true  
                };
              }
        }),
        getOnGoingBulkDocumentUpload: builder.mutation({
            query: crmId => ({
                url: `/crm/client/document/bulk/uploading/${crmId}`,
                method: 'GET'
            })
        }),
        completeBulkDocumentUpload: builder.mutation({
            query: id => ({
                url: `/crm/client/document/bulk/complete/${id}`,
                method: 'POST'
            })
        }),
    })
})

export const { 
    useGetCrmDetailsMutation,
    useGetClientAndAccountsMutation,
    useUpdateClientAndAccountsMutation,
    useDeleteClientMutation,
    useDeleteAccountMutation,
    useCreateClientAccountMutation,
    useGetClientsBasicDetailsMutation,
    useGetAccountsBasicDetailsMutation,
    useGetClientDocumentsMutation,
    useAddClientDocumentsMutation,
    useDeleteClientDocumentMutation,
    useAddBulkClientDocumentsMutation,
    useGetOnGoingBulkDocumentUploadMutation,
    useCompleteBulkDocumentUploadMutation
} = formDetailsApiSlice